module.exports = __webpack_public_path__ + "static/media/rodape.d3280225.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/rodape.png
// module id = 462
// module chunks = 6